var _rect, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCinematic = function SvgCinematic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.6132,
    height: 41.6132,
    fill: "url(#pattern0_910_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_910_171",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_910_171",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_910_171",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACY0lEQVR4nO3dvWsUQRiA8U3QRgs/OrUUbGxEbQKCoLWlrZDG1tLW0tZ/wUIhvYXYCOIHkkYRtBStVBCihfjFI8ftoUjY3SOzk3dmnx9Me5OZB/Yye8td00iSJEmSJEmSJE0csAZcdpBirKUIsoFS2TBILAaZYpDPwGbPqMVmz5jtxa4H6Z2ESjQZ9sogSzBIMAYJxiDBGCQYgwRjkGBKCeLBkFgHQw1nkGAMEkzxQZ4BP6hH8UHWgRPAfepQfpDm799xCXhH2eoJMgPsB24CPylTliCv203qGkmCLACngMfk17fO2V5UfVJf73jNFeAK8IFMcuxVsUEWgIPALeAXI2t6GOQfwGngKSNqehjkP8Bqexn7xAgGzG+Q7QCH28vYbxIaMK9BugDngBck0jmZQYYB9gDXgC12qJQgD4AzPWPXgiwAR4G77EzfOmd7MZ2TegrAeeDVLq3HINsB9raXsS+Z12OQLsAx4HbG9RhkCODCgPtQKRhkCOAi8CbDegzSxUtWvDf1r5nXY5Ap/ttbysHwCHCHCRwMo986WQWuTunWSdggwFngOYnk2KsqgwCHvP3e/Rq5PqBaaT+g+sgIcuxVNUGYP4nyhBHl2KvigwAHfMhhyUnGCsL8acb3ZJJjr5oEk7wErveM1A/KnQQekl/fOmd7MZ2TOrAPuAF8p0z1BGF+eXpL2coPAhwH7lGH4oM8Ar5Rj+KD1MYgwRgkGL84YIpfHOBXawQ7qRukZZDMcuyVQZZgkGAMEoxBgjFIMKUE8WBIrIOhhjNIMAapMYg/eUSgnzySJEmSJEmSJElqyvYH4FQw9n0cwFYAAAAASUVORK5CYII="
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCinematic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cinematic.50c70d80.svg";
export { ForwardRef as ReactComponent };